import {
  Home,
  Building2,
  HardHat,
  Palmtree,
  Map,
  Receipt,
  Landmark,
  TrendingUp,
  PiggyBank,
  Rocket,
  Leaf,
  Target,
  FileSearch,
  Briefcase,
  Wallet,
  ShieldCheck,
  BadgeCheck,
  Scale,
  MonitorSmartphone,
} from "lucide-react";

const MAP = {
  Home,
  Building2,
  HardHat,
  Palmtree,
  Map,
  Receipt,
  Landmark,
  TrendingUp,
  PiggyBank,
  Rocket,
  Leaf,
  Target,
  FileSearch,
  Briefcase,
  Wallet,
  ShieldCheck,
  BadgeCheck,
  Scale,
  MonitorSmartphone,
};

export function getIcon(name) {
  return MAP[name] || Home;
}
